// src/components/UserFiles/hooks/useGroupedFiles.js
import { useMemo } from 'react';

const GROUP_COLORS = [
  'rgba(25,118,210,0.08)',  // light blue
  'rgba(56,142,60,0.08)',   // light green
  'rgba(251,140,0,0.08)',   // light orange
  'rgba(123,31,162,0.08)',  // light purple
];

export const useGroupedFiles = (files) => {
  return useMemo(() => {
    if (!files || files.length === 0) return [];

    const groupsMap = new Map();

    files.forEach((file) => {
      const key = file.anonymization_group_id || `single-${file.id}`;
      if (!groupsMap.has(key)) groupsMap.set(key, []);
      groupsMap.get(key).push(file);
    });

    return Array.from(groupsMap.entries()).map(([groupId, groupItems], idx) => ({
      id: groupId,
      files: groupItems,
      color: GROUP_COLORS[idx % GROUP_COLORS.length],
      isRealGroup: !!groupItems[0].anonymization_group_id,
    }));
  }, [files]);
};
